import { connectStepper } from "../util/redux";
import Tapping from "../components/tapping";

export default connectStepper(Tapping);
